import HttpService from "@/modules/core/network/http-service";

class PartService extends HttpService {
  constructor() {
    super("stock/part");
  }
}

export default new PartService();
